<template>
  <div :class="`zhandianbox ${type ? 'zhandianbox1' : ''}`">
    <div class="zhandian">
      <div v-for="(item, index) in list" class="p10">
        <a :href="item.url">
          <p class="h pb10 fs2">{{ item.name }}</p>
          <!-- <p>
            <span class="blink1 h fs3">{{ item.signature.split(".")[0] }}</span>
            <span>.{{ item.signature.split(".")[1] }}</span>
          </p> -->
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from "vue";
import { data2 } from "../utils/data";

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "站点推荐⬇⬇⬇⬇",
  },
});

const { list } = toRefs(props);
</script>

<style lang="scss" scoped>
.zhandianbox {
  border: 2px solid #555555;
  border-radius: 5px;
}
.zhandian {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  text-align: center;
  div {
    border: 1px solid #555;
    background-color: #c2c2c2;
    width: 100%;
    border-radius: 5px;
    padding: 10px 0;
    a {
      color: #0609f1;
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
}
.zhandianbox1 {
  .zhandian {
    gap: 5px;
    div {
      width: 100%;
      border-radius: 5px;
      background-color: #d3fffb !important;
      a {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>